import { Provider as ReduxProvider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router/immutable';
import { Route } from 'react-router-dom';
import Modal from 'react-modal';
import { QueryClient, QueryClientProvider } from 'react-query';

import history from './configureHistory';

// Import root app
import App from './modules/App';

// Load the favicon
import './assets/favicon/favicon.ico';
import './assets/favicon/apple-touch-icon-57x57.png';
import './assets/favicon/apple-touch-icon-60x60.png';
import './assets/favicon/apple-touch-icon-72x72.png';
import './assets/favicon/apple-touch-icon-76x76.png';
import './assets/favicon/apple-touch-icon-114x114.png';
import './assets/favicon/apple-touch-icon-120x120.png';
import './assets/favicon/apple-touch-icon-144x144.png';
import './assets/favicon/apple-touch-icon-152x152.png';

// Import Global Styles
import './global-styles/global-styles.scss';

import configureStore from './configureStore';

import { Analytics } from './utils/Analytics';
import { ABTesting } from '@capitalise/common';
import AnalyticsProvider from './modules/AnalyticsProvider';

import React from 'react';

import { AuthProviderAlpha } from 'RemoteAuth/Auth';

Modal.setAppElement('#app');

const initialState = {};

const store = configureStore(initialState, history);
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

Analytics.init();
// Define A/B testing experiments
ABTesting.init(!['production', 'demo'].includes(window._env_.RUNNING_ENV));

const Bootstrap = () => {
  return (
    <ReduxProvider store={store}>
      <QueryClientProvider client={queryClient}>
        <ConnectedRouter history={history}>
          <AnalyticsProvider analyticsService={Analytics}>
            <AuthProviderAlpha>
              <Route component={App} />
            </AuthProviderAlpha>
          </AnalyticsProvider>
        </ConnectedRouter>
      </QueryClientProvider>
    </ReduxProvider>
  );
};

export default Bootstrap;
